import React from 'react';
import Modal from '@omilia/modal';

// @ts-ignore
import messages from 'constants/messages';
import { SContainer } from '../styled';
import ModalLoader from '../ModalLoader';

type Props = { branchName: string };

const MergeBranchLoadingModal = ({ branchName }: Props) => (
  <Modal
    open
    data-test="version-control-modal"
    glyph="merge"
    hasBackdrop={false}
    subtitle={`${branchName} into its parent branch`}
    title="Merge Branch"
  >
    <SContainer>
      {messages.VERSION_CONTROL.MERGE_MODAL.MERGING_BRANCH}
      <ModalLoader text={messages.VERSION_CONTROL.MERGE_REQUEST} />
    </SContainer>
  </Modal>
);

export default MergeBranchLoadingModal;
